import { action } from 'satcheljs';

/**
 * Action to enable/disable a booking meetingType from the store.
 */
const enableEditStateMeetingType = action('ENABLE_DISABLE_PBP_SERVICE', (enable: boolean) => ({
    enable,
}));

export default enableEditStateMeetingType;
